import React, { useContext } from 'react';
import { updateThreshold } from 'flow/store/redux/thunks/thresholdUpdates';
import RHSTextField from './RHSTextField';
import { useAppDispatch } from '~/store/reduxHooks';
import { ThresholdContext } from '../context';

interface RHSCreatableProps {
  shouldUseDefaultString: boolean;
}

const RHSCreatable = ({ shouldUseDefaultString }: RHSCreatableProps) => {
  const dispatch = useAppDispatch();
  const { populatedThreshold } = useContext(ThresholdContext);

  const { publicId, right: { attributeValue } } = populatedThreshold;

  const onChange = (newValue: string) => {
    dispatch(updateThreshold.rightValue(publicId, newValue));
  };

  const values = attributeValue != null ? String(attributeValue).split(',') : [''];

  return (
    <RHSTextField
      onChange={onChange}
      shouldUseDefaultString={shouldUseDefaultString}
      value={values[0]}
    />
  );
};

export default RHSCreatable;

